import React from "react";

const OrderContext = React.createContext();
OrderContext.displayName = "OrderContext";

export default OrderContext;
